import React from "react";
import "./Products.css";

const whatsappNumber = "918368305178";

const hairCareData = [
  {
    id: "shampoo",
    name: "PPS - Pure Prakritik Shampoo",
    tagline: "Gentle cleansing, rooted in tradition",
    image: "/products/shampoo.jpg",
    sizes: ["100ml", "200ml"],
    ingredients: [
      "Amla",
      "Shikakai",
      "Bhringraj",
      "Reetha",
      "Rosemary",
      "Hibiscus Flower",
      "Methidana",
      "Flax Seeds",
      "Vegetable Glycerin",
      "Vitamin E oil",
      "Premium Shampoo Base (SLS & Paraben Free)",
    ],
    benefits: [
      "Strengthens roots & prevents graying",
      "Cleanses scalp gently, naturally",
      "Reactivates dormant hair follicles",
      "Rich, natural lather - no harsh sulfates",
      "Boosts growth & reduces shedding",
      "Deeply conditions & tames frizz",
      "Adds soft, luminous shine",
    ],
    badge: "Paraben & SLS Free",
  },
  {
    id: "oil",
    name: "PPS - Pure Prakritik Sampoorna Hair Oil",
    tagline: "Deep nourishment, drop by drop",
    image: "/products/oil.jpg",
    sizes: ["50ml", "100ml"],
    ingredients: [
      "Amla",
      "Shikakai",
      "Bhringraj",
      "Flaxseed",
      "Rosemary",
      "Methidana",
      "Kalonji",
      "Hibiscus",
      "Aloe Vera",
      "Neem Leaves",
      "Curry Leaves",
      "Rose Petals",
      "Vitamin E oil",
      "Almond Oil",
      "Castor Oil",
      "Sesame Oil",
      "Cold Pressed Coconut Oil Base",
    ],
    benefits: [
      "Strengthens roots & prevents graying",
      "Reactivates dormant hair follicles",
      "Improves strand elasticity & flexibility",
      "Boosts growth & reduces shedding",
      "Calms scalp inflammation",
      "Eliminates itchy dandruff fungi",
      "Deep penetration for lasting shine",
    ],
    badge: "17 Handpicked Ingredients",
  },
];

const makhanaData = [
  {
    id: "caramel",
    name: "Gud Caramel Makhana",
    tagline: "Sweet, crunchy, roasted to perfection",
    image: "/products/makhana-caramel.jpg",
    size: "65g pack",
    ingredients: [
      "Roasted Fox Nuts (Makhana)",
      "Jaggery (Gud)",
      "Ghee",
      "A pinch of Salt",
    ],
    benefits: [
      "Light, guilt-free sweet snack",
      "Naturally high in plant protein",
      "Low in fat, gluten-free",
      "Perfect for evening cravings",
    ],
    badge: "Sweet & Crunchy",
  },
  {
    id: "pudina",
    name: "Pudina Makhana",
    tagline: "Cool mint with a tangy roasted crunch",
    image: "/products/makhana-pudina.jpg",
    size: "65g pack",
    ingredients: [
      "Roasted Fox Nuts (Makhana)",
      "Mint (Pudina) Powder",
      "Rock Salt",
      "Roasted Spice Blend",
    ],
    benefits: [
      "Refreshing, tangy mint flavor",
      "Rich in fiber",
      "Low glycemic index, diabetic-friendly",
      "Rich in antioxidants"
    ],
    badge: "Refreshing Mint",
  },
  {
    id: "bhuna-jeera",
    name: "Bhuna Jeera Makhana",
    tagline: "Classic roasted cumin, deeply desi",
    image: "/products/makhana-bhuna-jeera.jpg",
    size: "65g pack",
    ingredients: [
      "Roasted Fox Nuts (Makhana)",
      "Roasted Cumin (Jeera) Powder",
      "Black Salt",
      "Traditional Spice Mix",
    ],
    benefits: [
      "Rich in antioxidants",
      "Good source of calcium & magnesium",
      "A nostalgic, homely flavor",
      "Low glycemic index, diabetic-friendly"
    ],
    badge: "Classic Roasted",
  },
  {
    id: "heeng",
    name: "Heeng Makhana",
    tagline: "Bold asafoetida, packed with flavor",
    image: "/products/makhana-heeng.jpg",
    size: "65g pack",
    ingredients: [
      
    ],
    benefits: [
      "Aids digestion & reduces bloating",
      "High in fiber & plant protein",
      "Bold, distinctive Indian flavor",
      "Low glycemic index, diabetic-friendly"
    ],
    badge: "Bold & Traditional",
  },
];

function HairCareCard({ product }) {
  const message = `Hi! I'd like to order ${product.name}`;
  const buyLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div className="product-card">
      <div className="product-image-wrap">
        <img src={product.image} alt={product.name} />
        <span className="product-badge">{product.badge}</span>
      </div>

      <div className="product-info">
        <h3>{product.name}</h3>
        <p className="product-tagline">{product.tagline}</p>

        <div className="product-sizes">
          {product.sizes.map((size) => (
            <span className="size-pill" key={size}>
              {size}
            </span>
          ))}
        </div>

        <div className="product-section">
          <h4>Key Benefits</h4>
          <ul className="benefits-list">
            {product.benefits.map((benefit, i) => (
              <li key={i}>
                <span className="check-icon">✓</span>
                {benefit}
              </li>
            ))}
          </ul>
        </div>

        <div className="product-section">
          <h4>Ingredients</h4>
          <div className="ingredients-tags">
            {product.ingredients.map((ing, i) => (
              <span className="ingredient-tag" key={i}>
                {ing}
              </span>
            ))}
          </div>
        </div>

        <a
          href={buyLink}
          target="_blank"
          rel="noopener noreferrer"
          className="buy-now-btn"
        >
          <svg
            className="buy-now-icon"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
          >
            <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.362.687 4.564 1.872 6.418L4 29l7.77-1.84A11.94 11.94 0 0 0 16.001 27C22.628 27 28 21.627 28 15S22.628 3 16.001 3zm0 21.818c-1.98 0-3.827-.55-5.404-1.505l-.387-.23-4.61 1.092 1.13-4.49-.253-.4A9.77 9.77 0 0 1 5.182 15c0-5.964 4.855-10.818 10.819-10.818S26.818 9.036 26.818 15 21.965 24.818 16.001 24.818zm5.978-8.14c-.328-.164-1.94-.957-2.24-1.066-.301-.109-.52-.164-.738.164-.219.328-.847 1.066-1.038 1.285-.191.219-.383.246-.71.082-.328-.164-1.386-.51-2.64-1.63-.976-.87-1.635-1.945-1.826-2.273-.191-.328-.02-.505.144-.668.148-.148.328-.383.492-.574.164-.191.219-.328.328-.547.109-.219.055-.41-.027-.574-.082-.164-.738-1.777-1.012-2.434-.267-.64-.539-.553-.738-.563l-.63-.012c-.219 0-.574.082-.874.41-.301.328-1.148 1.121-1.148 2.734s1.175 3.172 1.339 3.39c.164.219 2.313 3.531 5.605 4.953.783.338 1.393.54 1.869.691.785.25 1.5.215 2.065.13.63-.094 1.94-.793 2.213-1.559.273-.766.273-1.422.191-1.559-.082-.137-.301-.219-.629-.383z" />
          </svg>
          Buy Now
        </a>
      </div>
    </div>
  );
}

function MakhanaCard({ product }) {
  const message = `Hi! I'd like to order ${product.name} (${product.size})`;
  const buyLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div className="product-card">
      <div className="product-image-wrap">
        <img src={product.image} alt={product.name} />
        <span className="product-badge">{product.badge}</span>
      </div>

      <div className="product-info">
        <h3>{product.name}</h3>
        <p className="product-tagline">{product.tagline}</p>

        <div className="product-sizes">
          <span className="size-pill">{product.size}</span>
        </div>

        <div className="product-section">
          <h4>Key Benefits</h4>
          <ul className="benefits-list">
            {product.benefits.map((benefit, i) => (
              <li key={i}>
                <span className="check-icon">✓</span>
                {benefit}
              </li>
            ))}
          </ul>
        </div>

        {/* <div className="product-section">
          <h4>Ingredients</h4>
          <div className="ingredients-tags">
            {product.ingredients.map((ing, i) => (
              <span className="ingredient-tag" key={i}>
                {ing}
              </span>
            ))}
          </div>
        </div> */}

        <a
          href={buyLink}
          target="_blank"
          rel="noopener noreferrer"
          className="buy-now-btn"
        >
          <svg
            className="buy-now-icon"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
          >
            <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.362.687 4.564 1.872 6.418L4 29l7.77-1.84A11.94 11.94 0 0 0 16.001 27C22.628 27 28 21.627 28 15S22.628 3 16.001 3zm0 21.818c-1.98 0-3.827-.55-5.404-1.505l-.387-.23-4.61 1.092 1.13-4.49-.253-.4A9.77 9.77 0 0 1 5.182 15c0-5.964 4.855-10.818 10.819-10.818S26.818 9.036 26.818 15 21.965 24.818 16.001 24.818zm5.978-8.14c-.328-.164-1.94-.957-2.24-1.066-.301-.109-.52-.164-.738.164-.219.328-.847 1.066-1.038 1.285-.191.219-.383.246-.71.082-.328-.164-1.386-.51-2.64-1.63-.976-.87-1.635-1.945-1.826-2.273-.191-.328-.02-.505.144-.668.148-.148.328-.383.492-.574.164-.191.219-.328.328-.547.109-.219.055-.41-.027-.574-.082-.164-.738-1.777-1.012-2.434-.267-.64-.539-.553-.738-.563l-.63-.012c-.219 0-.574.082-.874.41-.301.328-1.148 1.121-1.148 2.734s1.175 3.172 1.339 3.39c.164.219 2.313 3.531 5.605 4.953.783.338 1.393.54 1.869.691.785.25 1.5.215 2.065.13.63-.094 1.94-.793 2.213-1.559.273-.766.273-1.422.191-1.559-.082-.137-.301-.219-.629-.383z" />
          </svg>
          DM to Order
        </a>
      </div>
    </div>
  );
}

function Products() {
  return (
    <section className="products">
      <div className="product-category" id="makhana">
        <div className="products-header">
          <span className="products-kicker">Royal Utsav Snacks</span>
          <h2>Roasted Makhana, 4 Bold Flavours</h2>
          <p className="products-intro">
            Handmade, hygienically roasted fox nuts - a light, nourishing snack
            for any time of day.
          </p>
          <span className="roasted-banner">🔥 100% Roasted, Never Fried</span>
        </div>
        ...
        <div className="products-grid">
          {makhanaData.map((product) => (
            <MakhanaCard product={product} key={product.id} />
          ))}
        </div>
      </div>

      <div className="section-divider">
        <span className="section-divider-icon">🌿</span>
      </div>

      <div className="product-category" id="hair-care">
        <div className="products-header">
          <span className="products-kicker">PPS · Pure Prakritik</span>
          <h2>Hair Care, Crafted the Prakritik Way</h2>
          <p className="products-intro">
            Handpicked, homemade, and made with love - every batch is used by us
            and our own family first.
          </p>
        </div>

        <div className="products-grid">
          {hairCareData.map((product) => (
            <HairCareCard product={product} key={product.id} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Products;
